import { http, id } from 'utils'
import { SET_ITEMS } from 'vx/mutations'

export default {
  namespaced: true,

  state: {
    products: []
  },

  actions: {
    async getProducts ({ commit, state }, { customerId, params = {} } = {}) {
      const response = await http.get(`customers/${id(customerId)}/products`, { params })
      commit(SET_ITEMS, response.data.data)

      return response
    },

    resetProducts ({ commit }) {
      commit(SET_ITEMS, [])
    }
  },

  mutations: {
    [SET_ITEMS] (state, items) {
      state.products = items
    }
  }
}
